module.exports = __webpack_public_path__ + "img/165-belgium.2aa2a028.svg";